"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnAtUsd = exports.EnAtEur = exports.DeAtUsd = exports.DeAtEur = void 0;
class DeAtEur {
    constructor() {
        this.locale = "de-at";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "EUR",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.DeAtEur = DeAtEur;
class DeAtUsd {
    constructor() {
        this.locale = "de-at";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d. MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeAtUsd = DeAtUsd;
class EnAtEur {
    constructor() {
        this.locale = "en-at";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "EUR",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnAtEur = EnAtEur;
class EnAtUsd {
    constructor() {
        this.locale = "en-at";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnAtUsd = EnAtUsd;
